import { GRID_DATA_LIMIT } from '../../../constants';
import { Dataset, JSONObject } from '../../../types/types';
import { getDataKey } from '../../../utils/getDataKey';
import { SubsetDataApiRequestData } from '../../types/types';
import { getDatasetDataApiRequestData } from './getDatasetDataApiRequestData';

export const getSubsetDataApiRequestData = (
  rowId: string,
  dataset: Dataset,
  activeSorting: any[],
  token: string | null,
  offset: number,
  filters?: Record<string, any>,
  limit: number | null = GRID_DATA_LIMIT,
  cachedQueryId?: string | null,
  itemsOverride?: string[],
  masterIdItem?: string,
  omitPagination?: boolean,
  datasetControl?: JSONObject,
  masterRowIds?: string[]
): SubsetDataApiRequestData => {
  const datasetData = getDatasetDataApiRequestData(
    dataset,
    activeSorting,
    token,
    offset,
    filters,
    limit,
    cachedQueryId,
    itemsOverride,
    omitPagination,
    datasetControl
  );
  return {
    ...datasetData,
    master: {
      id: rowId,
      ...(masterRowIds && masterRowIds.length > 0
        ? { ids: masterRowIds }
        : {}),
      idItem: masterIdItem ?? getDataKey(dataset),
    },
  };
};
